import { render } from "./PrintReceipt.vue?vue&type=template&id=28c5b61f&scoped=true"
import script from "./PrintReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReceipt.vue?vue&type=script&lang=js"

import "./PrintReceipt.vue?vue&type=style&index=0&id=28c5b61f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c5b61f"]])

export default __exports__